import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysBatchComponent } from '../sys-batch/sys-batch';
import { SysMaintenanceComponent } from '../sys-maintenance/sys-maintenance';
import { SysPrivilegeComponent } from '../sys-privilege/sys-privilege';
import { SysSystemComponent } from '../sys-system/sys-system';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-sys-container',
  standalone: true,
  imports: [
    CommonModule,
    SysBatchComponent,
    SysMaintenanceComponent,
    SysPrivilegeComponent,
    SysSystemComponent
  ],
  templateUrl: './sys-container.html',
  styleUrl: './sys-container.css'
})
export class SysContainerComponent implements OnInit {
  activeTab: string = '';
  visitedTabs = new Set<string>();

  tabs: { id: string; name: string; minLevel?: number }[] = [];

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.initializeTabs();
  }

  // AdminLevelに基づいてタブを初期化
  private initializeTabs(): void {
    const adminLevel = this.authService.getAdminLevel() ?? 0;

    const allTabs: { id: string; name: string; minLevel: number }[] = [
      { id: 'sys-privilege',   name: '特権管理',         minLevel: 5 },
      { id: 'sys-batch',       name: 'バッチ管理',         minLevel: 5 },
      { id: 'sys-maintenance', name: 'メンテナンス設定',   minLevel: 5 },
      { id: 'system-settings', name: 'システム設定',       minLevel: 5 }
    ];

    this.tabs = allTabs.filter(tab => adminLevel >= tab.minLevel);

    // デフォルトのアクティブタブを最初のタブに設定
    if (this.tabs.length > 0) {
      this.activeTab = this.tabs[0].id;
      this.visitedTabs.add(this.activeTab);
    }
  }

  switchTab(tabId: string): void {
    this.activeTab = tabId;
    this.visitedTabs.add(tabId);
  }
}
